import React, { SetStateAction } from 'react'
import { Form, FormControl, InputGroup } from 'react-bootstrap'
import SearchIcon from '../Icons/SearchIcon'
import '../kyc/kycStyle.css'

interface Props {
  searchText: string
  handleSearch: (value: string) => void
  placeHolder: string
  autoFocus?: boolean
}

export const SearchInput: React.FC<Props> = ({
  searchText,
  handleSearch,
  placeHolder,
  autoFocus,
}) => {
  return (
    <Form>
      <InputGroup
        className="mb-3"
        style={{ display: 'flex', maxWidth: '430px' }}
      >
        <FormControl
          placeholder={placeHolder}
          autoFocus={autoFocus}
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          style={{
            flex: '1 1 auto',
            minWidth: '0',
            position: 'relative',
            width: '1%',
          }}
          className={'custom-input'}
        />
        {/* <InputGroup.Text style={{ lineHeight: '24px' }}>
          <SearchIcon />
        </InputGroup.Text> */}
      </InputGroup>
    </Form>
  )
}
